import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-notes.manage.edit', {
        url: '/edit',
        component: 'companySharingCenterSharedNoteManage',
       // resolve:{theNote}
    });
}





// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-notes/manage/manage-shared-note.state.js